// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"870":"d5c98fc6413439ed","2435":"213ec57ac52c6e2e","5892":"340e96d919dc989d","7107":"de77f9725fdcd97c"}[chunkId] + ".css";
};